/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjCore from "@grapecity/wijmo"
import * as wjcInput from "@grapecity/wijmo.input"
// immutable
import { copyObject, DataChangeEventArgs } from "@grapecity/wijmo.grid.immutable"
import { DataChangeAction } from "@grapecity/wijmo.grid.immutable"
import { ImmutabilityProvider } from "@grapecity/wijmo.react.grid.immutable"

import { useContext, useEffect, useState } from "react"
import { Button, Col, Container, OverlayTrigger, Popover, Row } from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux"
import { AppDispatch } from "../../../.."
import { RootState } from "../../../../globalStore/rootreducer"
import {
  TZenrekiData,
  TKeirekiData,
  TSikakuData,
  THyosyorekiData,
  TSidoTyokairekiData,
  TMenkyoKosinRirekiData,
  TZikorekiData,
  TUntenKirokuSyomeiData,
  TClaimrekiData,
  TAlcoholData,
  TMenkyoFileData,
} from "../../../../globalStore/pageStore/zyomuinMaster/kakusyuRirekiData"
import CONSTANT from "../../../../constant"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"
import { zyomuinMasterActions } from "../../../../globalStore/pageStore/zyomuinMaster/zyomuinMasterStore"
import { TPictureFile } from "../../../../globalStore/pageStore/zyomuinMaster/baseData"
import { HashLink } from "react-router-hash-link"
import dayjs from "dayjs"
import RequiredHeader from "../../../../components/FlexGridWrapper/RequiredHeader"
import util from "../../../../ts/util"
import ContentService from "../../../../service/content/contentService"
import saveAs from "file-saver"
import { setAlerts } from "../../../../globalStore/alertStore"
import SingleFileUploadModal from "./ModalComponent/AttachedSingleFileModal"
import { BlobContext } from "../ZyomuinMasterRegisterContext"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import dateUtil from "../../../../ts/util/dateUtil"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons"
import KubunService from "../../../../service/master/kubun/kubunService"
import { 区分分類コード } from "../../../../constant/enum/codes"
import commonUtil from "../../../../ts/util/commonUtil"

//#region [type]
export type T事故歴 = TZikorekiData & {
  fileData: TPictureFile
}

export type Tクレーム歴 = TClaimrekiData & {
  fileData: TPictureFile
}

//#endregion

/**
 * 各種履歴Accordion
 */
const KakusyuRirekiPane = () => {
  //#region [selector]
  const zyomuinMaster = useSelector((state: RootState) => state.page.zyomuinMaster)
  const disPatch: AppDispatch = useDispatch()
  const { addBlobItem, removeBlobItem } = useContext(BlobContext)
  //#endregion

  //#region [method]

  // wijmo日付入力とstore対応用
  const toInputDateValueToDateString = (
    inputDateValue: string | Date | undefined,
    format: string = "YYYY/MM/DD"
  ): string | undefined => {
    if (inputDateValue == null || inputDateValue === "") return undefined
    return dayjs(inputDateValue).format(format)
  }

  // グリッド共通
  const onSelectionChanged = (grid: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    if (e.row < 0 || e.col < 0) return
    // 日付カラム選択時の挙動制御
    if (e.getColumn().editor instanceof wjcInput.InputDate) {
      // row_idを持たないdataItemは新規行入力中アイテムと判定
      const dataItem = e.getRow().dataItem
      const isEditingNewRowCell = dataItem != null && (dataItem.row_id ?? "") === ""

      // 新規行入力中の場合
      if (isEditingNewRowCell) {
        // フォーカスを与えて日付選択を行いやすくする
        grid.startEditing(false)
        setTimeout(() => {
          e.getColumn().editor?.onGotFocus()
        }, 0)
      }
    }
  }

  /**
   * セル編集開始時イベント
   * @param s
   * @param e
   * @returns
   */
  // グリッド共通 (無理なら個別に用意する)
  const onBeginningEdit = (s: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    if (e.panel === s.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        const rowData: { 削除フラグ?: number } = e.getRow().dataItem
        if (rowData.削除フラグ === 1) {
          e.cancel = true
          return
        }
      }
    }
  }

  // グリッド共通 (無理なら個別に用意する)
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        const rowData: { 削除フラグ?: number } = e.getRow().dataItem
        if (rowData == null) return

        // 削除フラグ
        if (!e.getColumn().isReadOnly) {
          wjcCore.toggleClass(e.cell, "read-only-cell", rowData.削除フラグ === 1)
        }

        // エラーセルの色変え
        // if (
        //   errorCellPositionList.find(
        //     (e) => e.colBinding === cellBinding && e.行ID === rowData.行ID
        //   )
        // ) {
        //   isExistData = false
        // }
        // wjcCore.toggleClass(e.cell, "data-warning", !isExistData)
      }
    }
  }

  const onPastingCell = (f: wjcGrid.FlexGrid, e: wjcGrid.CellRangeEventArgs) => {
    if (e.row < 0 || e.col < 0) return

    const rowData: { 削除フラグ?: number } = e.getRow().dataItem
    if (rowData == null) return
    if (rowData.削除フラグ === 1) e.cancel = true
  }

  //#endregion

  //#region [color2] 前歴
  const initGridZenreki = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridZenreki(grid)
  }

  /**
   * 前歴グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on前歴GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TZenrekiData
    const 入学入社日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input入学入社日) ?? ""
    const 卒業退社日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input卒業退社日) ?? ""

    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          zyomuinMasterActions.add前歴テーブル({
            ...castedNewItem,
            入学入社日,
            input入学入社日: 入学入社日 === "" ? "" : castedNewItem.input入学入社日,
            卒業退社日,
            input卒業退社日: 卒業退社日 === "" ? "" : castedNewItem.input卒業退社日,
          })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          zyomuinMasterActions.remove前歴テーブル({
            row_id: castedNewItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit前歴テーブル({
            ...castedNewItem,
            入学入社日,
            input入学入社日: 入学入社日 === "" ? "" : castedNewItem.input入学入社日,
            卒業退社日,
            input卒業退社日: 卒業退社日 === "" ? "" : castedNewItem.input卒業退社日,
          })
        )
        break
      default:
        console.log("例外")
    }
  }
  //#endregion

  //#region [color2] 経歴
  const initGridKeireki = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridKeireki(grid)
  }

  /**
   * 経歴グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on経歴GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TKeirekiData
    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          zyomuinMasterActions.add経歴テーブル({
            ...castedNewItem,
          })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          zyomuinMasterActions.remove経歴テーブル({
            row_id: castedNewItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit経歴テーブル({
            ...castedNewItem,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  //#endregion

  //#region [color2] 資格
  const initGridSikaku = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridSikaku(grid)
  }

  /**
   * 資格グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on資格GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TSikakuData
    const 資格取得日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input資格取得日) ?? ""

    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          zyomuinMasterActions.add資格テーブル({
            ...castedNewItem,
            資格取得日,
            input資格取得日: 資格取得日 === "" ? "" : castedNewItem.input資格取得日,
          })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          zyomuinMasterActions.remove資格テーブル({
            row_id: castedNewItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit資格テーブル({
            ...castedNewItem,
            資格取得日,
            input資格取得日: 資格取得日 === "" ? "" : castedNewItem.input資格取得日,
          })
        )
        break
      default:
        console.log("例外")
    }
  }

  //#endregion

  //#region [color2] 表彰歴
  const initGridHyosyoreki = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridHyosyoreki(grid)
  }

  /**
   * 表彰歴グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on表彰歴GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as THyosyorekiData
    const 表彰日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input表彰日) ?? ""
    switch (e.action) {
      case DataChangeAction.Add:
        // edit表彰歴テーブル dispatch によるRedux更新 → ImmutabilityProvider itemsSource更新 →
        // Wijmo _commitRowEdits が偽のAddイベントを発火する場合がある。
        // 既にRedux storeに存在するrow_idならその偽イベントとして無視する。
        if (castedNewItem.row_id && zyomuinMaster.表彰歴データリスト.some((item: THyosyorekiData) => item.row_id === castedNewItem.row_id)) {
          break
        }
        disPatch(
          zyomuinMasterActions.add表彰歴テーブル({
            ...castedNewItem,
            表彰日,
            input表彰日: 表彰日 === "" ? "" : castedNewItem.input表彰日,
          })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          zyomuinMasterActions.remove表彰歴テーブル({
            row_id: castedNewItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit表彰歴テーブル({
            ...castedNewItem,
            表彰日,
            input表彰日: 表彰日 === "" ? "" : castedNewItem.input表彰日,
          })
        )
        break
      default:
        console.log("例外")
    }
  }

  const add表彰歴添付ファイル = async (file: File | undefined, fileUrl: string) => {
    if (selected表彰歴データ != null) {
      const updateItem: THyosyorekiData = {
        ...selected表彰歴データ,
        添付ファイル: {
          isNewFile: true,
          ファイル名: file?.name ?? "",
          ファイルURL: fileUrl,
        },
      }
      disPatch(zyomuinMasterActions.edit表彰歴テーブル(updateItem))

      // Fileをコンテキスト経由で保持
      addBlobItem({ id: updateItem.row_id!, blob: file!, fileUrl: fileUrl })
    }
    setIsShowHyosyorekiEditModal(false)
  }

  //#endregion

  //#region [color2] 指導懲戒歴
  const initGridSidoTyokaireki = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridSidoTyokaireki(grid)
  }

  /**
   * 指導懲戒歴グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on指導懲戒歴GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TSidoTyokairekiData
    const 指導懲戒日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input指導懲戒日) ?? ""

    switch (e.action) {
      case DataChangeAction.Add:
        // edit指導懲戒歴テーブル dispatch によるRedux更新 → ImmutabilityProvider itemsSource更新 →
        // Wijmo _commitRowEdits が偽のAddイベントを発火する場合がある。
        // 既にRedux storeに存在するrow_idならその偽イベントとして無視する。
        if (castedNewItem.row_id && zyomuinMaster.指導懲戒歴データリスト.some((item: TSidoTyokairekiData) => item.row_id === castedNewItem.row_id)) {
          break
        }
        disPatch(
          zyomuinMasterActions.add指導懲戒歴テーブル({
            ...castedNewItem,
            指導懲戒日,
            input指導懲戒日: 指導懲戒日 === "" ? "" : castedNewItem.input指導懲戒日,
          })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          zyomuinMasterActions.remove指導懲戒歴テーブル({
            row_id: castedNewItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit指導懲戒歴テーブル({
            ...castedNewItem,
            指導懲戒日,
            input指導懲戒日: 指導懲戒日 === "" ? "" : castedNewItem.input指導懲戒日,
          })
        )
        break
      default:
        console.log("例外")
    }
  }

  const add指導懲戒歴添付ファイル = async (file: File | undefined, fileUrl: string) => {
    if (selected指導懲戒歴データ != null) {
      const updateItem: TSidoTyokairekiData = {
        ...selected指導懲戒歴データ,
        添付ファイル: {
          isNewFile: true,
          ファイル名: file?.name ?? "",
          ファイルURL: fileUrl,
        },
      }
      disPatch(zyomuinMasterActions.edit指導懲戒歴テーブル(updateItem))

      // Fileをコンテキスト経由で保持
      addBlobItem({ id: updateItem.row_id!, blob: file!, fileUrl: fileUrl })
    }
    setIsShowSidourekiEditModal(false)
  }

  //#endregion

  //#region [color2] 免許更新履歴
  const initGridMenkyoKosinRireki = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridMenkyoKosinRireki(grid)
  }

  /**
   * 免許更新履歴グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on免許更新履歴GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TMenkyoKosinRirekiData

    const 免許更新日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input免許更新日) ?? ""
    const 有効期限 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input有効期限) ?? ""
    const 面談日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input面談日) ?? ""

    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          zyomuinMasterActions.add免許更新履歴テーブル({
            ...castedNewItem,
            免許更新日,
            input免許更新日: 免許更新日 === "" ? "" : castedNewItem.input免許更新日,
            有効期限,
            input有効期限: 有効期限 === "" ? "" : castedNewItem.input有効期限,
            面談日,
            input面談日: 面談日 === "" ? "" : castedNewItem.input面談日,
          })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          zyomuinMasterActions.remove免許更新履歴テーブル({
            row_id: castedNewItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit免許更新履歴テーブル({
            ...castedNewItem,
            免許更新日,
            input免許更新日: 免許更新日 === "" ? "" : castedNewItem.input免許更新日,
            有効期限,
            input有効期限: 有効期限 === "" ? "" : castedNewItem.input有効期限,
            面談日,
            input面談日: 面談日 === "" ? "" : castedNewItem.input面談日,
          })
        )
        break
      default:
        console.log("例外")
    }
  }
  //#endregion

  // #region 免許ファイル
  const initGridMenkyoFile = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridMenkyoFile(grid)
  }

  /**
   * 免許ファイルグリッド編集イベント
   * @param s grid
   * @param e
   */
  const on免許ファイルGridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TMenkyoFileData & { row_id: string }

    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          zyomuinMasterActions.add免許ファイル一覧テーブル({
            ...castedNewItem,
          })
        )
        break
      case DataChangeAction.Remove:
        // Store反映
        disPatch(zyomuinMasterActions.remove免許ファイル一覧テーブル(castedNewItem))

        // Blob解放
        if (castedNewItem.ファイル != null) removeBlobItem(castedNewItem.row_id)
        break

      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit免許ファイル一覧テーブル({
            ...castedNewItem,
          })
        )
        break
      default:
        console.log("例外")
    }
  }

  const add免許ファイル = async (file: File | undefined, fileUrl: string) => {
    const updateItem: TMenkyoFileData = {
      row_id: commonUtil.getUniqueStr(),
      HasファイルAtStart: false,
      ファイル: {
        isNewFile: true,
        ファイル名: file?.name ?? "",
        ファイルURL: fileUrl,
      },
    }
    disPatch(zyomuinMasterActions.add免許ファイル一覧テーブル(updateItem))

    // Fileをコンテキスト経由で保持
    addBlobItem({ id: updateItem.row_id!, blob: file!, fileUrl: fileUrl })

    setIsShowMenkyoFileEditModal(false)
  }

  //#endregion

  // #region 事故歴
  const initGridZikoreki = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridZikoreki(grid)
  }

  /**
   * 事故歴グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on事故歴GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TZikorekiData
    const 発生日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input発生日) ?? ""
    switch (e.action) {
      case DataChangeAction.Add:
        if (castedNewItem.row_id && zyomuinMaster.事故歴データリスト.some((item: TZikorekiData) => item.row_id === castedNewItem.row_id)) {
          break
        }
        disPatch(
          zyomuinMasterActions.add事故歴テーブル({
            ...castedNewItem,
            発生日,
            input発生日: 発生日 === "" ? "" : castedNewItem.input発生日,
          })
        )
        break
      case DataChangeAction.Remove:
        // Store反映
        disPatch(zyomuinMasterActions.remove事故歴テーブル(castedNewItem))

        // Blob解放
        if (castedNewItem.添付ファイル != null) removeBlobItem(castedNewItem.row_id)
        break

      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit事故歴テーブル({
            ...castedNewItem,
            発生日,
            input発生日: 発生日 === "" ? "" : castedNewItem.input発生日,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  const add事故歴添付ファイル = async (file: File | undefined, fileUrl: string) => {
    if (selected事故歴データ != null) {
      const updateItem: TZikorekiData = {
        ...selected事故歴データ,
        添付ファイル: {
          isNewFile: true,
          ファイル名: file?.name ?? "",
          ファイルURL: fileUrl,
        },
      }
      disPatch(zyomuinMasterActions.edit事故歴テーブル(updateItem))

      // Fileをコンテキスト経由で保持
      addBlobItem({ id: updateItem.row_id!, blob: file!, fileUrl: fileUrl })
    }
    setIsShowZikorekiEditModal(false)
  }

  //#endregion

  // #region [color2] 運転記録証明
  const initGridUntenKirokuSyomei = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridUntenKirokuSyomei(grid)
  }

  /**
   * 運転記録証明グリッド編集イベント
   * @param s grid
   * @param e
   */
  const on運転記録証明GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TUntenKirokuSyomeiData
    const 違反日 = dateUtil.toISoDateStringBy和暦含Format(castedNewItem.input違反日) ?? ""
    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          zyomuinMasterActions.add運転記録証明テーブル({
            ...castedNewItem,
            違反日,
            input違反日: 違反日 === "" ? "" : castedNewItem.input違反日,
          })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          zyomuinMasterActions.remove運転記録証明テーブル({
            row_id: castedNewItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.edit運転記録証明テーブル({
            ...castedNewItem,
            違反日,
            input違反日: 違反日 === "" ? "" : castedNewItem.input違反日,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  //#endregion

  // #region クレーム歴
  const initGridClaimreki = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridClaimreki(grid)
  }

  /**
   * クレーム歴グリッド編集イベント
   * @param s grid
   * @param e
   */
  const onクレーム歴GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TClaimrekiData
    switch (e.action) {
      case DataChangeAction.Add:
        if (castedNewItem.row_id && zyomuinMaster.クレーム歴データリスト.some((item: TClaimrekiData) => item.row_id === castedNewItem.row_id)) {
          break
        }
        disPatch(
          zyomuinMasterActions.addクレーム歴テーブル({
            ...castedNewItem,
            発生日: toInputDateValueToDateString(castedNewItem.発生日),
            受付日: toInputDateValueToDateString(castedNewItem.受付日),
          })
        )
        break
      case DataChangeAction.Remove:
        // Store反映
        disPatch(zyomuinMasterActions.removeクレーム歴テーブル(castedNewItem))

        // Blob解放
        if (castedNewItem.添付ファイル != null) removeBlobItem(castedNewItem.row_id)
        break

      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.editクレーム歴テーブル({
            ...castedNewItem,
            発生日: toInputDateValueToDateString(castedNewItem.発生日),
            受付日: toInputDateValueToDateString(castedNewItem.受付日),
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  const addクレーム歴添付ファイル = async (file: File | undefined, fileUrl: string) => {
    if (selectedクレーム歴データ != null) {
      const updateItem: TClaimrekiData = {
        ...selectedクレーム歴データ,
        添付ファイル: {
          isNewFile: true,
          ファイル名: file?.name ?? "",
          ファイルURL: fileUrl,
        },
      }
      disPatch(zyomuinMasterActions.editクレーム歴テーブル(updateItem))

      // Fileをコンテキスト経由で保持
      addBlobItem({ id: updateItem.row_id!, blob: file!, fileUrl: fileUrl })
    }
    setIsShowClaimrekiEditModal(false)
  }
  //#endregion

  //#region [color2] アルコール反応
  const initGridAlcohol = (grid: wjcGrid.FlexGrid) => {
    grid.selectionChanged.addHandler(onSelectionChanged)
    grid.beginningEdit.addHandler(onBeginningEdit)
    grid.pastingCell.addHandler(onPastingCell)
    grid.formatItem.addHandler(formatItem)

    setFlexGridAlcohol(grid)
  }

  /**
   * アルコール反応グリッド編集イベント
   * @param s grid
   * @param e
   */
  const onアルコール反応GridDataChanged = (s: wjrGrid.FlexGrid, e: DataChangeEventArgs) => {
    const castedNewItem = e.newItem as TAlcoholData

    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          zyomuinMasterActions.addアルコール反応テーブル({
            ...castedNewItem,
            測定日時: toInputDateValueToDateString(castedNewItem.測定日時_入力用, "YYYY/MM/DD HH:mm"),
            再測定フラグ: castedNewItem.再測定フラグ ? 1 : 0,
          })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          zyomuinMasterActions.removeアルコール反応テーブル({
            row_id: castedNewItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          zyomuinMasterActions.editアルコール反応テーブル({
            ...castedNewItem,
            測定日時: toInputDateValueToDateString(castedNewItem.測定日時_入力用, "YYYY/MM/DD HH:mm"),
            再測定フラグ: castedNewItem.再測定フラグ ? 1 : 0,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  //#endregion

  //#endregion

  //#region [state]
  // 前歴
  const [, setFlexGridZenreki] = useState<wjcGrid.FlexGrid>()

  // 経歴
  const [, setFlexGridKeireki] = useState<wjcGrid.FlexGrid>()

  // 資格
  const [, setFlexGridSikaku] = useState<wjcGrid.FlexGrid>()

  // 表彰歴
  const [, setFlexGridHyosyoreki] = useState<wjcGrid.FlexGrid>()
  const [isShowHyosyorekiEditModal, setIsShowHyosyorekiEditModal] = useState(false)
  const [isShowDeleteHyosyorekiFileConfirmModal, setIsShowDeleteHyosyorekiFileConfirmModal] = useState(false)
  const [selected表彰歴データ, setSelected表彰歴データ] = useState<THyosyorekiData | undefined>()

  // 指導懲戒歴
  const [, setFlexGridSidoTyokaireki] = useState<wjcGrid.FlexGrid>()
  const [指導懲戒区分データマップ, set指導懲戒区分データマップ] = useState<wjcGrid.DataMap<string, string>>()
  const [isShowSidourekiEditModal, setIsShowSidourekiEditModal] = useState(false)
  const [isShowDeleteSidourekiFileConfirmModal, setIsShowDeleteSidourekiFileConfirmModal] = useState(false)
  const [selected指導懲戒歴データ, setSelected指導懲戒歴データ] = useState<TSidoTyokairekiData | undefined>()

  // 免許更新履歴
  const [, setFlexGridMenkyoKosinRireki] = useState<wjcGrid.FlexGrid>()

  // 免許
  const [, setFlexGridMenkyoFile] = useState<wjcGrid.FlexGrid>()
  const [isShowMenkyoFileEditModal, setIsShowMenkyoFileEditModal] = useState(false)

  // 事故歴
  const [, setFlexGridZikoreki] = useState<wjcGrid.FlexGrid>()
  const [isShowZikorekiEditModal, setIsShowZikorekiEditModal] = useState(false)
  const [isShowDeleteZikorekiFileConfirmModal, setIsShowDeleteZikorekiFileConfirmModal] = useState(false)
  const [selected事故歴データ, setSelected事故歴データ] = useState<TZikorekiData | undefined>()

  // 運転記録証明
  const [, setFlexGridUntenKirokuSyomei] = useState<wjcGrid.FlexGrid>()

  // クレーム歴
  const [, setFlexGridClaimreki] = useState<wjcGrid.FlexGrid>()
  const [isShowClaimrekiEditModal, setIsShowClaimrekiEditModal] = useState(false)
  const [isShowDeleteClaimrekiFileConfirmModal, setIsShowDeleteClaimrekiFileConfirmModal] = useState(false)
  const [selectedクレーム歴データ, setSelectedクレーム歴データ] = useState<TClaimrekiData | undefined>()

  // アルコール反応
  const [, setFlexGridAlcohol] = useState<wjcGrid.FlexGrid>()

  //#endregion

  //#region [effect]
  useEffect(() => {
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      // GridのComboBox用DataMap
      const 指導懲戒区分dataMap = new wjcGrid.DataMap(
        区分マスタRes.data.filter((d) => d.分類コード === 区分分類コード.社員_乗務員.指導懲戒区分),
        "区分ID",
        "名称1"
      )
      set指導懲戒区分データマップ(指導懲戒区分dataMap)
    })
  }, [])
  //#endregion

  //#endregion

  return (
    <>
      <div className="accordion-header">
        <span>各種履歴</span>
        <div className="accordion-description">各種履歴</div>
      </div>

      <div>
        <Row>
          <Col>
            {/* 各種履歴までジャンプ */}
            <ul className="list-cmn d-flex  border border-secondary">
              <li>
                <HashLink smooth to="#Zenreki">
                  前歴
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#Keireki">
                  経歴
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#Sikaku">
                  資格
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#Hyosyoreki">
                  表彰歴
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#SidoTyokaireki">
                  指導・懲戒歴
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#MenkyoKosinRireki">
                  免許更新履歴
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#Zikoreki">
                  事故歴
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#UntenKirokuSyomei">
                  運転記録証明
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#Claimreki">
                  クレーム歴
                </HashLink>
              </li>
              <li className="list-cmn list-padding">
                <HashLink smooth to="#Alcohol">
                  アルコール反応
                </HashLink>
              </li>
            </ul>
            <div className="w-100 text-end">
              <OverlayTrigger
                trigger="hover"
                overlay={
                  <Popover placement="left-end" className="fs-5 max-w-120rem" id={`help-popover`}>
                    <Popover.Header as="h1">日付入力について</Popover.Header>
                    <Popover.Body>
                      <p>以下の一覧の日付入力は和暦での入力が可能です。</p>
                      <ul>
                        <li>前歴 </li>
                        <li>資格</li>
                        <li>表彰歴 </li>
                        <li>指導・懲戒歴</li>
                        <li>免許更新履歴</li>
                        <li>事故歴</li>
                        <li>運転記録証明</li>
                      </ul>
                      <div>入力例: H24/01/01 ⇒ 平成24年1月1日</div>
                      <div>(昭和:S, 平成:H, 令和:R)</div>
                    </Popover.Body>
                  </Popover>
                }>
                <span>
                  <FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>
                  日付入力について
                </span>
              </OverlayTrigger>
            </div>
            <h5 id="Zenreki">前歴</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT} initialized={initGridZenreki}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.前歴データリスト}
                      dataChanged={on前歴GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="input入学入社日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="入学・入社日"
                      isRequired={false}
                      format={"d"}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TZenrekiData>) => {
                          return util.date.show和暦含Format(context.item.入学入社日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="input卒業退社日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="卒業・退社日"
                      format={"d"}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TZenrekiData>) => {
                          return util.date.show和暦含Format(context.item.卒業退社日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="学校会社名" width={300} header="名称">
                      <RequiredHeader></RequiredHeader>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="備考" width={300} header="備考"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TZenrekiData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit前歴テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員前歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove前歴テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit前歴テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="Keireki">経歴</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT} initialized={initGridKeireki}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.経歴データリスト}
                      dataChanged={on経歴GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn binding="自動車種類" width={150} header="自動車種類">
                      <RequiredHeader></RequiredHeader>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="車載量" width={100} header="車載量"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="経験年数" width={90} header="経験年数" isRequired={false}>
                      <RequiredHeader></RequiredHeader>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="主な事業所"
                      width={300}
                      header="主な事業所"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TKeirekiData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit経歴テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員経歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove経歴テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit経歴テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="Sikaku">資格</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT} initialized={initGridSikaku}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.資格データリスト}
                      dataChanged={on資格GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="input資格取得日"
                      isRequired={false}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="資格取得日"
                      format={"d"}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TSikakuData>) => {
                          return util.date.show和暦含Format(context.item.資格取得日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="資格名称" width={300} isRequired={false} header="資格名称">
                      <RequiredHeader></RequiredHeader>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="資格番号"
                      width={150}
                      isRequired={false}
                      header="資格番号"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="備考"
                      width={300}
                      isRequired={false}
                      header="備考"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TSikakuData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit資格テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員資格歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove資格テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit資格テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="Hyosyoreki">表彰歴</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    initialized={initGridHyosyoreki}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.表彰歴データリスト}
                      dataChanged={on表彰歴GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="input表彰日"
                      isRequired={false}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="表彰日"
                      format={"d"}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<THyosyorekiData>) => {
                          return util.date.show和暦含Format(context.item.表彰日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="表彰名称" isRequired={false} width={300} header="表彰名称">
                      <RequiredHeader></RequiredHeader>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="表彰組織"
                      isRequired={false}
                      width={300}
                      header="表彰組織"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="内容"
                      isRequired={false}
                      width={300}
                      header="内容"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="添付ファイル名"
                      width={250}
                      header="添付ファイル名"
                      cssClass={"read-only-cell"}
                      cssClassAll={"read-only-cell"}
                      isReadOnly={true}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<THyosyorekiData>) => {
                          if (context.item.添付ファイル == null) return ""
                          return (
                            <a
                              href={context.item.添付ファイル.ファイルURL}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                if (!context.item.添付ファイル?.isNewFile) {
                                  e.preventDefault()
                                  const service = new ContentService()
                                  service
                                    .get(context.item.添付ファイル!.ファイルURL)
                                    .then((blob) => {
                                      saveAs(blob, context.item.添付ファイル?.ファイル名)
                                    })
                                    .catch((err) => disPatch(setAlerts(err)))
                                }
                              }}>
                              {context.item.添付ファイル.ファイル名}
                            </a>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    {/* 列見出しは空文字にしない（AYANAS.md §4.3 スクリーンリーダーで情報が正しく伝わるか / WCAG 2.2 SC 1.3.1） */}
                    <wjrGrid.FlexGridColumn binding="" width={100} isReadOnly={true} header="添付操作">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<THyosyorekiData>) => {
                          if (context.item.row_id == null) return
                          if (context.item.添付ファイル != null) {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"caution"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelected表彰歴データ(context.item)
                                  setIsShowDeleteHyosyorekiFileConfirmModal(true)
                                }}>
                                添付削除
                              </Button>
                            )
                          } else {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"working"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelected表彰歴データ(context.item)

                                  setIsShowHyosyorekiEditModal(true)
                                }}>
                                添付
                              </Button>
                            )
                          }
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<THyosyorekiData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit表彰歴テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員表彰歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove表彰歴テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit表彰歴テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="SidoTyokaireki">指導・懲戒歴</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    initialized={initGridSidoTyokaireki}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.指導懲戒歴データリスト}
                      dataChanged={on指導懲戒歴GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="input指導懲戒日"
                      isRequired={false}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="指導・懲戒日"
                      format={"d"}>
                      <RequiredHeader></RequiredHeader>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TSidoTyokairekiData>) => {
                          return util.date.show和暦含Format(context.item.指導懲戒日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="指導懲戒区分ID"
                      width={80}
                      dataMap={指導懲戒区分データマップ}
                      header="区分">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="ColumnHeader"
                        template={() => {
                          return (
                            <>
                              <span>区分</span>
                            </>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="指導懲戒名称"
                      width={300}
                      isRequired={false}
                      header="指導・懲戒名称">
                      <RequiredHeader></RequiredHeader>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="指導者"
                      width={150}
                      isRequired={false}
                      header="指導者"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="内容" width={300} header="内容"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="添付ファイル名"
                      width={250}
                      header="添付ファイル名"
                      cssClass={"read-only-cell"}
                      cssClassAll={"read-only-cell"}
                      isReadOnly={true}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TSidoTyokairekiData>) => {
                          if (context.item.添付ファイル == null) return ""
                          return (
                            <a
                              href={context.item.添付ファイル.ファイルURL}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                if (!context.item.添付ファイル?.isNewFile) {
                                  e.preventDefault()
                                  const service = new ContentService()
                                  service
                                    .get(context.item.添付ファイル!.ファイルURL)
                                    .then((blob) => {
                                      saveAs(blob, context.item.添付ファイル?.ファイル名)
                                    })
                                    .catch((err) => disPatch(setAlerts(err)))
                                }
                              }}>
                              {context.item.添付ファイル.ファイル名}
                            </a>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    {/* 列見出しは空文字にしない（AYANAS.md §4.3 スクリーンリーダーで情報が正しく伝わるか / WCAG 2.2 SC 1.3.1） */}
                    <wjrGrid.FlexGridColumn binding="" width={100} isReadOnly={true} header="添付操作">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TSidoTyokairekiData>) => {
                          if (context.item.row_id == null) return
                          if (context.item.添付ファイル != null) {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"caution"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelected指導懲戒歴データ(context.item)
                                  setIsShowDeleteSidourekiFileConfirmModal(true)
                                }}>
                                添付削除
                              </Button>
                            )
                          } else {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"working"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelected指導懲戒歴データ(context.item)

                                  setIsShowSidourekiEditModal(true)
                                }}>
                                添付
                              </Button>
                            )
                          }
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>

                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TSidoTyokairekiData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit指導懲戒歴テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員指導懲戒歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove指導懲戒歴テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit指導懲戒歴テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="MenkyoKosinRireki">免許更新履歴</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    initialized={initGridMenkyoKosinRireki}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.免許更新履歴データリスト}
                      dataChanged={on免許更新履歴GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="input免許更新日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      isRequired={false}
                      header="更新日"
                      format={"d"}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TMenkyoKosinRirekiData>) => {
                          return util.date.show和暦含Format(context.item.免許更新日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="免許証番号"
                      width={130}
                      isRequired={false}
                      header="免許証番号"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="input有効期限"
                      isRequired={false}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="有効期限"
                      format={"d"}>
                      <RequiredHeader></RequiredHeader>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TMenkyoKosinRirekiData>) => {
                          return util.date.show和暦含Format(context.item.有効期限)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="SDカード色"
                      isRequired={false}
                      width={100}
                      header="カラー"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="input面談日"
                      isRequired={false}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="面談日"
                      format={"d"}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TMenkyoKosinRirekiData>) => {
                          return util.date.show和暦含Format(context.item.面談日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="面談内容"
                      isRequired={false}
                      width={300}
                      header="面談内容"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="面談者"
                      isRequired={false}
                      width={150}
                      header="面談者"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TMenkyoKosinRirekiData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit免許更新履歴テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員免許更新歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove免許更新履歴テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit免許更新履歴テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="menkyoFile">運転免許画像</h5>

            <Container fluid>
              <Row>
                <Col>
                  <Button
                    className="btn btn-small btn-primary move-edit-page"
                    variant={"working"}
                    onClick={() => {
                      // 選択行データ
                      setIsShowMenkyoFileEditModal(true)
                    }}>
                    添付
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    initialized={initGridMenkyoFile}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.免許ファイルリスト}
                      dataChanged={on免許ファイルGridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="ファイル名"
                      width={250}
                      header="ファイル名"
                      cssClass={"read-only-cell"}
                      cssClassAll={"read-only-cell"}
                      isReadOnly={true}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TMenkyoFileData>) => {
                          if (context.item.ファイル == null) return ""
                          return (
                            <a
                              href={context.item.ファイル.ファイルURL}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                if (!context.item.ファイル?.isNewFile) {
                                  e.preventDefault()
                                  const service = new ContentService()
                                  service
                                    .get(context.item.ファイル!.ファイルURL)
                                    .then((blob) => {
                                      saveAs(blob, context.item.ファイル?.ファイル名)
                                    })
                                    .catch((err) => disPatch(setAlerts(err)))
                                }
                              }}>
                              {context.item.ファイル.ファイル名}
                            </a>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TMenkyoFileData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit免許ファイル一覧テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員運転免許添付資料ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove免許ファイル一覧テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit免許ファイル一覧テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="Zikoreki">事故歴</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT} initialized={initGridZikoreki}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.事故歴データリスト}
                      dataChanged={on事故歴GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="input発生日"
                      isRequired={false}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="発生日"
                      format={"d"}>
                      <RequiredHeader></RequiredHeader>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TZikorekiData>) => {
                          return util.date.show和暦含Format(context.item.発生日)
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="車番"
                      isRequired={false}
                      width={130}
                      header="車番(ナンバー)"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="事故種類"
                      isRequired={false}
                      width={120}
                      header="種類"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="責任"
                      width={120}
                      isRequired={false}
                      header="責任"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="概要"
                      isRequired={false}
                      width={500}
                      header="概要"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="添付ファイル名"
                      width={250}
                      header="添付ファイル名"
                      cssClass={"read-only-cell"}
                      cssClassAll={"read-only-cell"}
                      isReadOnly={true}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TZikorekiData>) => {
                          if (context.item.添付ファイル == null) return ""
                          return (
                            <a
                              href={context.item.添付ファイル.ファイルURL}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                if (!context.item.添付ファイル?.isNewFile) {
                                  e.preventDefault()
                                  const service = new ContentService()
                                  service
                                    .get(context.item.添付ファイル!.ファイルURL)
                                    .then((blob) => {
                                      saveAs(blob, context.item.添付ファイル?.ファイル名)
                                    })
                                    .catch((err) => disPatch(setAlerts(err)))
                                }
                              }}>
                              {context.item.添付ファイル.ファイル名}
                            </a>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    {/* 列見出しは空文字にしない（AYANAS.md §4.3 スクリーンリーダーで情報が正しく伝わるか / WCAG 2.2 SC 1.3.1） */}
                    <wjrGrid.FlexGridColumn binding="" width={100} isReadOnly={true} header="添付操作">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TZikorekiData>) => {
                          if (context.item.row_id == null) return
                          if (context.item.添付ファイル != null) {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"caution"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelected事故歴データ(context.item)
                                  setIsShowDeleteZikorekiFileConfirmModal(true)
                                }}>
                                添付削除
                              </Button>
                            )
                          } else {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"working"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelected事故歴データ(context.item)

                                  setIsShowZikorekiEditModal(true)
                                }}>
                                添付
                              </Button>
                            )
                          }
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TZikorekiData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit事故歴テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員事故歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove事故歴テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit事故歴テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="UntenKirokuSyomei">運転記録証明</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    initialized={initGridUntenKirokuSyomei}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.運転記録証明データリスト}
                      dataChanged={on運転記録証明GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="input違反日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      isRequired={false}
                      header="違反日"
                      format={"d"}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TUntenKirokuSyomeiData>) => {
                          return util.date.show和暦含Format(context.item.違反日)
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="違反内容" isRequired={false} width={300} header="違反内容">
                      <RequiredHeader></RequiredHeader>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="違反点数"
                      isRequired={false}
                      width={60}
                      header="点数"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="備考"
                      isRequired={false}
                      width={500}
                      header="備考"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TUntenKirokuSyomeiData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.edit運転記録証明テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員運転記録証明ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.remove運転記録証明テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.edit運転記録証明テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="Claimreki">クレーム歴</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    initialized={initGridClaimreki}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.クレーム歴データリスト}
                      dataChanged={onクレーム歴GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="発生日"
                      isRequired={true}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_WAREKI_INPUT_SIZE}
                      header="発生日"
                      editor={
                        new wjcInput.InputDate(document.createElement("div"), {
                          gotFocus: (control: wjcInput.InputDate) => {
                            control.isDroppedDown = true
                          },
                        })
                      }
                      format={"d"}>
                      <RequiredHeader></RequiredHeader>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TClaimrekiData>) => {
                          return (
                            <>
                              {context.item.発生日 != null &&
                                wjcCore.Globalize.format(new Date(context.item.発生日), "d")}
                            </>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="車番"
                      isRequired={false}
                      width={130}
                      header="車番(ナンバー)"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="場所"
                      isRequired={false}
                      width={120}
                      header="場所"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="概要" isRequired={false} width={300} header="概要">
                      <RequiredHeader></RequiredHeader>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="相手先氏名"
                      width={120}
                      header="相手先氏名"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="相手先電話番号"
                      isRequired={false}
                      width={120}
                      header="相手先TEL"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="対応者"
                      isRequired={false}
                      width={120}
                      header="対応者"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="受付日"
                      isRequired={false}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_INPUT_SIZE}
                      header="受付日"
                      editor={
                        new wjcInput.InputDate(document.createElement("div"), {
                          gotFocus: (control: wjcInput.InputDate) => {
                            control.isDroppedDown = true
                          },
                        })
                      }
                      format={"d"}>
                      <RequiredHeader></RequiredHeader>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TClaimrekiData>) => {
                          return (
                            <>
                              {context.item.受付日 != null &&
                                wjcCore.Globalize.format(new Date(context.item.受付日), "d")}
                            </>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="添付ファイル名"
                      width={250}
                      header="添付ファイル名"
                      cssClass={"read-only-cell"}
                      cssClassAll={"read-only-cell"}
                      isReadOnly={true}>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TClaimrekiData>) => {
                          if (context.item.添付ファイル == null) return ""
                          return (
                            <a
                              href={context.item.添付ファイル.ファイルURL}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                if (!context.item.添付ファイル?.isNewFile) {
                                  e.preventDefault()
                                  const service = new ContentService()
                                  service
                                    .get(context.item.添付ファイル!.ファイルURL)
                                    .then((blob) => {
                                      saveAs(blob, context.item.添付ファイル?.ファイル名)
                                    })
                                    .catch((err) => disPatch(setAlerts(err)))
                                }
                              }}>
                              {context.item.添付ファイル.ファイル名}
                            </a>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    {/* 列見出しは空文字にしない（AYANAS.md §4.3 スクリーンリーダーで情報が正しく伝わるか / WCAG 2.2 SC 1.3.1） */}
                    <wjrGrid.FlexGridColumn binding="" width={100} isReadOnly={true} header="添付操作">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TClaimrekiData>) => {
                          if (context.item.row_id == null) return
                          if (context.item.添付ファイル != null) {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"caution"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelectedクレーム歴データ(context.item)
                                  setIsShowDeleteClaimrekiFileConfirmModal(true)
                                }}>
                                添付削除
                              </Button>
                            )
                          } else {
                            return (
                              <Button
                                className="btn btn-small btn-primary move-edit-page"
                                variant={"working"}
                                onClick={() => {
                                  // 選択行データ
                                  setSelectedクレーム歴データ(context.item)

                                  setIsShowClaimrekiEditModal(true)
                                }}>
                                添付
                              </Button>
                            )
                          }
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="row_id" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TClaimrekiData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.editクレーム歴テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.乗務員クレーム歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.removeクレーム歴テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.editクレーム歴テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Row>
          <Col>
            <h5 id="Alcohol">アルコール反応</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT} initialized={initGridAlcohol}>
                    <ImmutabilityProvider
                      itemsSource={zyomuinMaster.アルコール反応データリスト}
                      dataChanged={onアルコール反応GridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="測定日時_入力用"
                      isRequired={false}
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_INPUT_SIZE}
                      header="測定日"
                      editor={
                        new wjcInput.InputDate(document.createElement("div"), {
                          gotFocus: (control: wjcInput.InputDate) => {
                            control.isDroppedDown = true
                          },
                        })
                      }
                      format={"d"}>
                      <RequiredHeader></RequiredHeader>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TAlcoholData>) => {
                          return (
                            <>
                              {context.item.測定日時_入力用 != null &&
                                wjcCore.Globalize.format(new Date(context.item.測定日時_入力用), "d")}
                            </>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="測定日時_入力用"
                      width={100}
                      isRequired={false}
                      header="測定時刻"
                      editor={
                        new wjcInput.InputTime(document.createElement("div"), {
                          gotFocus: (control: wjcInput.InputTime) => {
                            control.isDroppedDown = true
                          },
                        })
                      }
                      format={"t"}>
                      <RequiredHeader></RequiredHeader>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TAlcoholData>) => {
                          return (
                            <>
                              {context.item.測定日時_入力用 != null &&
                                wjcCore.Globalize.format(new Date(context.item.測定日時_入力用), "HH:mm")}
                            </>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>

                    <wjrGrid.FlexGridColumn binding="AL測定値" width={100} isRequired={false} header="数値">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TAlcoholData>) => {
                          // 小数点0.000
                          let num = (context.item.AL測定値 ?? 0) * 1000
                          let floorNum = Math.floor(num)
                          let dispNum = floorNum / 1000
                          return <>{dispNum}</>
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="AL判定レベル"
                      isRequired={false}
                      width={100}
                      header="判定レベル"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="再測定フラグ"
                      isRequired={false}
                      width={130}
                      dataType={wjCore.DataType.Boolean}
                      header="10分以内再測定"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn binding="" width={60} isReadOnly={true} header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(context: TWijmoCellTemplateContext<TAlcoholData>) => {
                          if (context.item.row_id == null) return
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={context.item.削除フラグ === 1 ? "pending" : "caution"}
                              onClick={() => {
                                // 解除
                                if (context.item.削除フラグ === 1) {
                                  disPatch(
                                    zyomuinMasterActions.editアルコール反応テーブル(
                                      Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 0 }))
                                    )
                                  )
                                } else {
                                  // 削除
                                  if (context.item.運転者AL反応歴ID == null) {
                                    disPatch(
                                      zyomuinMasterActions.removeアルコール反応テーブル({
                                        row_id: context.item.row_id!,
                                      })
                                    )
                                  } else {
                                    disPatch(
                                      zyomuinMasterActions.editアルコール反応テーブル(
                                        Object.freeze(copyObject({}, { ...context.item, 削除フラグ: 1 }))
                                      )
                                    )
                                  }
                                }
                                context.col?.grid?.refresh()
                              }}>
                              {context.item.削除フラグ === 1 ? "解除" : "削除"}
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </div>
      <SingleFileUploadModal
        isShow={isShowMenkyoFileEditModal}
        setIsShow={setIsShowMenkyoFileEditModal}
        addItem={add免許ファイル}
        fileData={undefined}
        isShowFileImage={false}
        fileImageUrl=""
        title="運転免許画像ファイル"></SingleFileUploadModal>
      <SingleFileUploadModal
        isShow={isShowZikorekiEditModal}
        setIsShow={setIsShowZikorekiEditModal}
        addItem={add事故歴添付ファイル}
        fileData={selected事故歴データ?.添付ファイル}
        isShowFileImage={false}
        fileImageUrl=""
        title="事故歴添付ファイル"></SingleFileUploadModal>
      <SingleFileUploadModal
        isShow={isShowClaimrekiEditModal}
        setIsShow={setIsShowClaimrekiEditModal}
        addItem={addクレーム歴添付ファイル}
        fileData={selectedクレーム歴データ?.添付ファイル}
        isShowFileImage={false}
        fileImageUrl=""
        title="クレーム歴添付ファイル"></SingleFileUploadModal>
      <SingleFileUploadModal
        isShow={isShowHyosyorekiEditModal}
        setIsShow={setIsShowHyosyorekiEditModal}
        addItem={add表彰歴添付ファイル}
        fileData={selected表彰歴データ?.添付ファイル}
        isShowFileImage={false}
        fileImageUrl=""
        title="表彰歴添付ファイル"></SingleFileUploadModal>
      <SingleFileUploadModal
        isShow={isShowSidourekiEditModal}
        setIsShow={setIsShowSidourekiEditModal}
        addItem={add指導懲戒歴添付ファイル}
        fileData={selected指導懲戒歴データ?.添付ファイル}
        isShowFileImage={false}
        fileImageUrl=""
        title="指導懲戒歴添付ファイル"></SingleFileUploadModal>
      <ConfirmModal
        isShow={isShowDeleteZikorekiFileConfirmModal}
        submitHandler={() => {
          if (selected事故歴データ) {
            // Blob解放
            if (selected事故歴データ.添付ファイル != null) removeBlobItem(selected事故歴データ.row_id)

            disPatch(
              zyomuinMasterActions.edit事故歴テーブル({
                ...selected事故歴データ,
                添付ファイル: undefined,
                発生日: toInputDateValueToDateString(selected事故歴データ.発生日),
              })
            )
          }
          setIsShowDeleteZikorekiFileConfirmModal(false)
        }}
        hideHandler={(isCancel) => {
          setIsShowDeleteZikorekiFileConfirmModal(false)
        }}>
        <p>添付ファイルを削除しますか？</p>
        <p>※実際の削除は登録ボタン押下時となります</p>
      </ConfirmModal>
      <ConfirmModal
        isShow={isShowDeleteClaimrekiFileConfirmModal}
        submitHandler={() => {
          if (selectedクレーム歴データ) {
            // Blob解放
            if (selectedクレーム歴データ.添付ファイル != null) removeBlobItem(selectedクレーム歴データ.row_id)

            disPatch(
              zyomuinMasterActions.editクレーム歴テーブル({
                ...selectedクレーム歴データ,
                添付ファイル: undefined,
                発生日: toInputDateValueToDateString(selectedクレーム歴データ.発生日),
                受付日: toInputDateValueToDateString(selectedクレーム歴データ.受付日),
              })
            )
          }
          setIsShowDeleteClaimrekiFileConfirmModal(false)
        }}
        hideHandler={(isCancel) => {
          setIsShowDeleteClaimrekiFileConfirmModal(false)
        }}>
        <p>添付ファイルを削除しますか？</p>
        <p>※実際の削除は登録ボタン押下時となります</p>
      </ConfirmModal>
      <ConfirmModal
        isShow={isShowDeleteHyosyorekiFileConfirmModal}
        submitHandler={() => {
          if (selected表彰歴データ) {
            // Blob解放
            if (selected表彰歴データ.添付ファイル != null) removeBlobItem(selected表彰歴データ.row_id)

            disPatch(
              zyomuinMasterActions.edit表彰歴テーブル({
                ...selected表彰歴データ,
                添付ファイル: undefined,
              })
            )
          }
          setIsShowDeleteHyosyorekiFileConfirmModal(false)
        }}
        hideHandler={(isCancel) => {
          setIsShowDeleteHyosyorekiFileConfirmModal(false)
        }}>
        <p>添付ファイルを削除しますか？</p>
        <p>※実際の削除は登録ボタン押下時となります</p>
      </ConfirmModal>
      <ConfirmModal
        isShow={isShowDeleteSidourekiFileConfirmModal}
        submitHandler={() => {
          if (selected指導懲戒歴データ) {
            // Blob解放
            if (selected指導懲戒歴データ.添付ファイル != null) removeBlobItem(selected指導懲戒歴データ.row_id)

            disPatch(
              zyomuinMasterActions.edit指導懲戒歴テーブル({
                ...selected指導懲戒歴データ,
                添付ファイル: undefined,
              })
            )
          }
          setIsShowDeleteSidourekiFileConfirmModal(false)
        }}
        hideHandler={(isCancel) => {
          setIsShowDeleteSidourekiFileConfirmModal(false)
        }}>
        <p>添付ファイルを削除しますか？</p>
        <p>※実際の削除は登録ボタン押下時となります</p>
      </ConfirmModal>
    </>
  )
}

export default KakusyuRirekiPane
